import Axios from 'axios';
import { config, SERVER_URL } from '../environment/env_dev';

export const getShipments = () => {
    return Axios.get(`${SERVER_URL}/api/Shipments`, config);
};
